import gql from 'graphql-tag';

export const getCommercialContactHistories = gql`
  query getCommercialContactHistories($id: ID!) {
    getCommercialContactHistories(id: $id) {
      id
      version
      updatedAt
      updater
    }
  }
`;
